import { __awaiter, __generator } from '../../../../../../_virtual/_tslib.js';
import { useState, useEffect } from 'react';
import { useToggleState } from '../../../../../../utils/common/dataTypes/boolean.js';
import { fetchWebpageMetadata } from './utils/fetchWebpageMetadata.js';
import { getUnsupportedSiteLinkPreviewData } from '../../../../../Offerings/modules/BrandedCommunity/components/LinkPreview/utils/LinkPreview.utils.js';

var useLinkPreview = function (_a) {
    var url = _a.url, apiKey = _a.apiKey, errorLogger = _a.errorLogger;
    var _b = useState(null), previewData = _b[0], setPreviewData = _b[1];
    var _c = useToggleState(false), isLoading = _c[0], startLoading = _c[1], stopLoading = _c[2];
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var unsupportedLinkData, handleError;
        return __generator(this, function (_a) {
            if (!url)
                return [2 /*return*/];
            unsupportedLinkData = getUnsupportedSiteLinkPreviewData(url);
            // if url belongs to an unsupported site, set preview data and return
            if (unsupportedLinkData) {
                setPreviewData(unsupportedLinkData);
                return [2 /*return*/];
            }
            startLoading();
            handleError = function (error) {
                if (errorLogger)
                    errorLogger({
                        error: error,
                        when: "fetching link preview",
                        occuredAt: "src/features/Common/modules/Urls&Routing/modules/LinkPreview/useLinkPreview.ts",
                        severity: "critical",
                    });
            };
            fetchWebpageMetadata({
                url: url,
                apiKey: apiKey,
                onSuccess: setPreviewData,
                onError: handleError,
                onFinally: stopLoading,
            });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        fetchData();
    }, [url]);
    return { previewData: previewData, isLoading: isLoading };
};

export { useLinkPreview as default };
//# sourceMappingURL=useLinkPreview.js.map
